(function(){
  'use strict';
  var cache = {};

  function getQuery() {
    try {
      var u = new URL(location.href);
      var q = u.searchParams.get('q');
      if (q) return q.trim();
    } catch(e) {}
    var inp = document.querySelector('predictive-search input[name="q"], .search-modal__form input[name="q"], form[action*="search"] input[name="q"]');
    if (inp && inp.value) return inp.value.trim();
    return '';
  }

  function extractHandle(href) {
    var m = (href || '').match(/\/products\/([a-z0-9\-_]+)/i);
    return m ? m[1] : null;
  }

  function attach(a, variantId) {
    var href = a.getAttribute('href') || '';
    if (href.indexOf('variant=') >= 0) return;
    var sep = href.indexOf('?') >= 0 ? '&' : '?';
    a.setAttribute('href', href + sep + 'variant=' + variantId);
  }

  function lookupAndRoute(href, q, callback) {
    var handle = extractHandle(href);
    if (!handle || !q) { callback(null); return; }
    var key = handle.toLowerCase();
    if (cache[key] !== undefined) {
      var v = (cache[key] || []).find(function(x){ return (x.sku || '').toLowerCase() === q.toLowerCase(); });
      callback(v ? v.id : null);
      return;
    }
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        var variants = (p && p.variants) || [];
        cache[key] = variants;
        var v = variants.find(function(x){ return (x.sku || '').toLowerCase() === q.toLowerCase(); });
        callback(v ? v.id : null);
      })
      .catch(function(){ callback(null); });
  }

  document.addEventListener('click', function(e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('variant=') >= 0) return;
    var q = getQuery();
    if (!q) return;
    var handle = extractHandle(href);
    if (!handle) return;
    var key = handle.toLowerCase();
    if (cache[key]) {
      var v = cache[key].find(function(x){ return (x.sku || '').toLowerCase() === q.toLowerCase(); });
      if (v) attach(a, v.id);
      return;
    }
    e.preventDefault();
    var target = a.getAttribute('target') || '_self';
    lookupAndRoute(href, q, function(variantId) {
      var sep = href.indexOf('?') >= 0 ? '&' : '?';
      var finalUrl = variantId ? (href + sep + 'variant=' + variantId) : href;
      if (target === '_blank') window.open(finalUrl, '_blank');
      else location.href = finalUrl;
    });
  }, true);
})();
